import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const LineChart = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M17 26H15C13.35 26 12 24.65 12 23V17C12 15.35 13.35 14 15 14H17C18.65 14 20 15.35 20 17V23C20 24.65 18.65 26 17 26ZM15 16C14.45 16 14 16.45 14 17V23C14 23.55 14.45 24 15 24H17C17.55 24 18 23.55 18 23V17C18 16.45 17.55 16 17 16H15Z" />
		<path d="M27 26H25C23.35 26 22 24.65 22 23V13C22 11.35 23.35 10 25 10H27C28.65 10 30 11.35 30 13V23C30 24.65 28.65 26 27 26ZM25 12C24.45 12 24 12.45 24 13V23C24 23.55 24.45 24 25 24H27C27.55 24 28 23.55 28 23V13C28 12.45 27.55 12 27 12H25Z" />
		<path d="M7 26H5C3.35 26 2 24.65 2 23V9C2 7.35 3.35 6 5 6H7C8.65 6 10 7.35 10 9V23C10 24.65 8.65 26 7 26ZM5 8C4.45 8 4 8.45 4 9V23C4 23.55 4.45 24 5 24H7C7.55 24 8 23.55 8 23V9C8 8.45 7.55 8 7 8H5Z" />
	</svg>
);

export default LineChart;
